import { render } from "./AdminRejectReasonDialog.vue?vue&type=template&id=1ead6fc4&scoped=true"
import script from "./AdminRejectReasonDialog.vue?vue&type=script&lang=js"
export * from "./AdminRejectReasonDialog.vue?vue&type=script&lang=js"

import "./AdminRejectReasonDialog.vue?vue&type=style&index=0&id=1ead6fc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ead6fc4"]])

export default __exports__